import React from 'react';
import { ArrowPathIcon, BoltIcon } from './Icons';

interface PWAUpdaterProps {
  onUpdate: () => void;
}

const PWAUpdater: React.FC<PWAUpdaterProps> = ({ onUpdate }) => {
  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] animate-in slide-in-from-top-4 duration-500 w-[90%] max-w-sm">
      <div className="bg-card-bg border-2 border-card-border p-4 rounded-2xl shadow-2xl flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="bg-brand-green-50 p-2 rounded-full">
            <BoltIcon className="w-5 h-5 text-brand-green" />
          </div>
          <div>
            <h4 className="text-sm font-black text-card-title">Update Ready</h4>
            <p className="text-[10px] font-bold text-app-text-secondary uppercase tracking-tighter">New features available</p>
          </div>
        </div>
        <button 
          onClick={onUpdate}
          className="bg-btn-primary text-btn-primary-text px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest flex items-center gap-2 hover:bg-btn-primary-hover shadow-lg"
        >
          <ArrowPathIcon className="w-3 h-3" />
          Refresh
        </button>
      </div>
    </div>
  );
};

export default PWAUpdater;